// extracted by mini-css-extract-plugin
export default {"TAF":"styles__TAF___IWFrF","hidden":"styles__hidden___qhVQB","flexColumn":"styles__flexColumn___QMw40","inheritWidth":"styles__inheritWidth___rrgwX"};